// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle2 from "../../randing/RandingStyle2";
import RandingStyle1 from "../../randing/RandingStyle1";

function Randing002({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/002/01_241101_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/002/01_241101_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/002/01_241101_02.gif`} // 스텝 변경되는 이미지
      numberColor="#0824a4"
      qOptionColor="blue"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/002/01_241101_03.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/002/02_241101_01.jpg`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing002;
